// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Divider, Form, Row, Select } from "antd";
import {
  FIELD_LENGTH,
  formItemBlockLayout,
  orderDescend
} from "../../../../utils/Constant";
import { SearchOutlined } from "@ant-design/icons";
import { BroadcastListsSearchRequestDTO } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import "moment/locale/fr";
import { BranchesStore } from "../../../../state/branches/BranchesStore";
import { BroadcastListsSearchFormProps } from "../../../types/BroadcastListTypes";
import { requestSearchBroadcastLists } from "../../../../state/broadcastLists/BroadcastListsEffects";
import FormField from "../../../components/FormField";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";

const BroadcastListsListSearchForm: React.FunctionComponent<BroadcastListsSearchFormProps> = (
  props: BroadcastListsSearchFormProps
) => {
  const {
    pagination,
    dataHasLoaded,
    setDataHasLoaded,
    onSearchDtoUpdate
  } = props;
  const { t } = useTranslation();

  const authentifiedUser = useStore(authentifiedUserStore);
  const branchList = useStore(BranchesStore);

  const handleSubmit = (values: any) => {
    setDataHasLoaded(false);
    const searchCriteria: BroadcastListsSearchRequestDTO = {
      branch: values.branch,
      name: values.name
    };
    onSearchDtoUpdate(searchCriteria);
    requestSearchBroadcastLists({
      pagination,
      sorter: {
        columnKey: "creationDate",
        order: orderDescend
      },
      dto: searchCriteria
    });
  };

  return (
    <Form {...formItemBlockLayout} onFinish={handleSubmit}>
      <div className="d-flex flex-row justify-content-end align-items-stretch flex-wrap">
        <div className="flex-grow-1 d-flex align-items-center">
          <Divider orientation="left" className="mb-0 mb-sm-3 mt-3">
            <h3 className="text-secondary mb-0">
              {t("broadcast_lists.search.title")}
            </h3>
          </Divider>
        </div>
        <div className="d-flex align-items-center divider-sm-transparent">
          <Divider orientation="right" className="mt-2 mt-sm-3 mb-3">
            <Button
              type="default"
              className="btn-tertiary"
              htmlType="submit"
              loading={!dataHasLoaded}
            >
              <SearchOutlined /> {t("news.global_buttons.search")}
            </Button>
          </Divider>
        </div>
      </div>
      <Row>
        {authentifiedUser?.branch === null && (
          <Col xs={24} sm={9} lg={6}>
            <Form.Item
              name="branch"
              key="branch"
              label={<span>{t("broadcast_lists.search.branch.label")}</span>}
              rules={[]}
            >
              <Select
                id="branch"
                placeholder={t("broadcast_lists.search.branch.placeholder")}
                allowClear
              >
                {Object.keys(branchList).map(key => (
                  <Select.Option key={key} value={key}>
                    {branchList[key].label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={9} lg={7}>
          <FormField
            labelName={t("broadcast_lists.search.name.label")}
            inputId="name"
            required={false}
            emptyErrorMessage={t("broadcast_lists.search.name.placeholder")}
            maxLength={FIELD_LENGTH.NAME}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default BroadcastListsListSearchForm;
